var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKiosker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 667 120",
    style: {
      enableBackground: "new 0 0 667 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_27_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    d: "M24.2,78.1H0v9.5h24.2c17.7,0,32.1,14.6,32.1,32.5h9.3C65.6,96.9,47,78.1,24.2,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    d: "M24.2,55.3H0v9.5h24.2c30.1,0,54.6,24.8,54.6,55.3h9.3C88.1,84.3,59.4,55.3,24.2,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    d: "M110.6,0h-9.3c0,20.2-7.4,39-21,53.5c-3.4-2.9-6.9-5.6-10.7-8C81.4,33.5,88.1,17.2,88.1,0h-9.3 c0,15.6-6.4,30.3-17.8,40.8c-4.7-2.2-9.6-4.1-14.7-5.4C57.9,27.9,65.6,14.9,65.6,0h-9.3c0,17.9-14.4,32.5-32.1,32.5H0v9.5h24.2 c42.5,0,77.1,35,77.1,78.1h9.3c0-23.2-9-44.3-23.5-60C102.3,43.8,110.6,22.6,110.6,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    d: "M161.5,91.1V28.7h11v29.9l26.1-29.9h13.1l-23.9,27.5l24.7,34.9h-12.9l-19.2-26.9l-7.8,8.7v18.3H161.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    d: "M222.9,91.1V28.7h11v62.4H222.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    d: "M256.8,83c-6.3-6.2-9.5-13.9-9.5-23s3.2-16.8,9.5-23c6.3-6.3,14-9.4,23.1-9.4c9.1,0,16.8,3.1,23.1,9.4 c6.4,6.2,9.5,13.9,9.5,23s-3.2,16.8-9.5,23c-6.3,6.2-14,9.3-23.2,9.3C270.8,92.3,263.1,89.2,256.8,83z M264.4,75.9 c4.2,4.2,9.4,6.4,15.5,6.4c6.1,0,11.2-2.1,15.4-6.4c4.2-4.3,6.3-9.6,6.3-15.8s-2.1-11.5-6.3-15.8c-4.2-4.3-9.3-6.4-15.4-6.4 c-6.1,0-11.3,2.1-15.5,6.4c-4.2,4.3-6.2,9.6-6.2,15.8C258.3,66.4,260.3,71.7,264.4,75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M328.1,72.7c3.2,6.4,8.3,9.5,15.5,9.5c7.7,0,10.4-4.1,10.4-8.1c0-2.8-1-4.7-3.5-6.4 c-2.6-1.8-4.4-2.6-9-4.3c-5.7-2.1-8.9-3.8-12.5-6.6c-3.5-3-5.2-7-5.2-12.3c0-5,1.9-9,5.5-12.2c3.7-3.1,8.2-4.7,13.6-4.7 c8.4,0,14.8,3.4,19,10.1l-7.9,5.5c-2.4-3.7-6-5.5-11-5.5c-4.9,0-8.4,2.8-8.4,6.6c0,2.6,1.1,3.8,2.6,5.4c1,0.7,3.4,1.8,4.6,2.4 l3.2,1.3l3.6,1.4c5.8,2.4,10,5,12.5,7.8c2.6,2.8,3.9,6.5,3.9,11.2c0,11-7.5,18.4-21.6,18.4c-11.4,0-19.8-5.4-23.7-14.2L328.1,72.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M377.8,91.1V28.7h11v29.9l26.1-29.9h13.1L404,56.2l24.7,34.9h-12.9l-19.2-26.9l-7.8,8.7v18.3H377.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    d: "M439,91.1V28.7h39.2v10.1H450v14.9h26.4v10.1H450V81h28.8v10.1H439z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    d: "M493.3,91.1V28.7h23.9c5.6,0,10.2,1.9,14.1,5.7c3.9,3.8,5.8,8.4,5.8,14c0,8.1-4.5,14.9-11.2,17.7 l14.9,24.9h-12.5l-13.2-22.2h-0.2h-10.8v22.2H493.3z M504.3,58.9h11.8c6,0,10.2-4.2,10.2-10.2c0-5.7-4-9.8-9.3-9.8h-12.6V58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    d: "M556.9,79.5c3.3,0,6.1,2.8,6.1,6.1c0,3.5-2.8,6.2-6.1,6.2c-3.3,0-6.2-2.7-6.2-6.2 C550.7,82.3,553.7,79.5,556.9,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    d: "M577.4,91.1V28.7h11v62.4H577.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M611.3,83c-6.3-6.2-9.5-13.9-9.5-23s3.2-16.8,9.5-23c6.3-6.3,14-9.4,23.1-9.4c9.1,0,16.8,3.1,23.1,9.4 c6.4,6.2,9.5,13.9,9.5,23s-3.2,16.8-9.5,23c-6.3,6.2-14,9.3-23.2,9.3C625.3,92.3,617.6,89.2,611.3,83z M618.9,75.9 c4.2,4.2,9.4,6.4,15.5,6.4c6.1,0,11.2-2.1,15.4-6.4c4.2-4.3,6.3-9.6,6.3-15.8s-2.1-11.5-6.3-15.8c-4.2-4.3-9.3-6.4-15.4-6.4 c-6.1,0-11.3,2.1-15.5,6.4c-4.2,4.3-6.2,9.6-6.2,15.8C612.7,66.4,614.8,71.7,618.9,75.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosker);
export default __webpack_public_path__ + "static/media/kiosker.95c54dc287afec57b52ed0ad24d308b6.svg";
export { ForwardRef as ReactComponent };